<template>
  <div id="image-tab-list" class="image-tab-list flex-column d-flex file-list ">
    <div v-for="(item,index) in files" :key="index">
      <ChatFile :show-thumb="false"
                :thumb="item.thumb"
                :file-ext="JSON.parse(item.params).fileExt"
                :title="item.title"
                :file-size="JSON.parse(item.params).fileSize"
                :href="item.href"
                :account-id="conversation.accountId"
                :message-id="item.msgId"
      />
      <div class="divider-custom" />
    </div>
    <scroll-loader :loader-method="getFiles" :loader-disable="noMore">
      <div v-loading="false"></div>
    </scroll-loader>
  </div>
</template>

<script>

import ChatFile from "../message/ChatFile";
import { COMMON } from "../../lib/Common";

export default {
  components: { ChatFile },
  props: ["conversation"],
  data() {
    return {
      noMore: false,
      files: [],
      ts: "",
      pageSize: 40
    };
  },
  methods: {
    updateFile(data) {
      let file = JSON.parse(data.content);
      this.files.unshift(file);
    },
    getFiles() {
      let request = {
        conversationId: this.conversation.id,
        accountId: this.conversation.accountId,
        timestamp: this.files.length > 0 ? this.files[this.files.length - 1].ts : "",
        msgTypes: [COMMON.CHAT_FILE],
        pageSize: this.pageSize
      };
      this.$http.post("/api/message/filter", request).then(resp => {
          let data = resp.data.map(s => {
            let con = JSON.parse(s.content);
            con.msgId = s.id;
            return con;
          });
          this.files = this.files.concat(data);
          if (resp.data.length < 40) this.noMore = true;
        }
      );
    }
  },
  mounted() {
    this.$bus.$on("updateFileTab", (data) => this.updateFile(data));
  },
  beforeDestroy() {
    this.$bus.$off("updateFileTab");
  }
};
</script>
<style scoped>
</style>
